import { type SkyName } from "../utils/mapWeather";

/**
 * The hazard that closes in on a match (0.98.4, owner decision, 31 October 2026, sky by sky: "Dusk : Instead of gas,
 * replace it with Dust storm as showcased in the artifact, a well designed, nice dust storm"; "Night mode ... replace
 * the gas with wildfire (the one you showed in artifact), same damage as gas, just different visual").
 *
 * The zone is the gas's (server/src/gas.ts: its stages, its circle, its damage, its mask) under every sky; what it is
 * differs by the sky: toxic gas on a clear day, in the snow and in a thunderstorm, a wall of dust at dusk and a
 * wildfire at night. The page draws each its own way (client/src/scripts/managers/hazardRender.ts), the HUD names it,
 * and the kill feed says what got a player. The server's rules don't change with it: the damage, the gas mask's
 * protection and the stages are the same for all three.
 */
export type HazardName = "gas" | "dust" | "wildfire";

/** the hazard of a sky */
export const hazardOfSky = (sky: SkyName | undefined): HazardName => {
    switch (sky) {
        case "dusk": return "dust";
        case "night": return "wildfire";
        default: return "gas";
    }
};

/** the hazard's words on the HUD and in the kill feed: a phrasebook key's middle part (`gas_waiting`, `kf_gas_kill`) */
export const hazardKey = (hazard: HazardName): string => hazard;
